export enum NamedTools {
  Pointer = 'Pointer',
  DrawSelection = 'DrawSelection',

  DrawPath = 'DrawPath',
  DrawRect = 'DrawRect',
  DrawEllipsis = 'DrawEllipsis',
  DrawLine = 'DrawLine',
  Zoom = 'Zoom',
  Pan = 'Pan',
  MagicWandSelector = 'MagicWandSelector',
  RectangleSelector = 'RectangleSelector',
  PickColor = 'PickColor',
  Text = 'Text',

  DrawElementTool = "DrawElementTool",

  Guides = 'Guides',
  Inspect = 'Inspect',
  Accessibility = 'Accessibility',
  Position = 'Position',
  Padding = "Padding",
  Margin = 'Margin',
  Flexbox = 'Flexbox',
  Move = 'Move',
  HueShift = 'HueShift',
  BoxShadows = 'BoxShadows',
  FontStyles = 'FontStyles'
}